import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f2ca909"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "product-list product-list_not-found"
}
const _hoisted_2 = { class: "product-list product-list_type_list" }
const _hoisted_3 = { class: "product-list product-list_type_grid" }

import { useProductsRepo } from '@/store';
import ProductListItem from './ProductListItem.vue';
import ProductCardItem from './ProductCardItem.vue';
import { IProduct } from '@/services';
import { ViewType, useChunkLoader } from '@/composables';
import { storeToRefs } from 'pinia';
import { watch, nextTick } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductListView',
  props: {
    viewType: null
  },
  setup(__props: any) {

const props = __props as {
  viewType: ViewType;
};



const { productsFiltered, isLoading } = storeToRefs(useProductsRepo());

const { array, chunkedArray, isEnd, load } = useChunkLoader<IProduct>(10);

watch(productsFiltered, () => {
  array.value = [...productsFiltered.value];
});

function loadCb(done: () => void) {
  load();
  nextTick(() => {
    done();
  });
}


return (_ctx: any,_cache: any) => {
  const _component_AppSpinner = _resolveComponent("AppSpinner")!
  const _component_AppInfiniteScroll = _resolveComponent("AppInfiniteScroll")!

  return (_unref(isLoading))
    ? (_openBlock(), _createBlock(_component_AppSpinner, { key: 0 }))
    : (_unref(productsFiltered).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "No products found"))
      : (__props.viewType === _unref(ViewType).List)
        ? (_openBlock(), _createBlock(_component_AppInfiniteScroll, {
            key: 2,
            onLoad: loadCb,
            disable: _unref(isEnd) && !_unref(isLoading)
          }, {
            loading: _withCtx(() => [
              _createVNode(_component_AppSpinner, { class: "loading" })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedArray), (product) => {
                  return (_openBlock(), _createBlock(ProductListItem, {
                    class: "product-list__item product-list__item_type_list",
                    key: product.id,
                    product: product
                  }, null, 8 /* PROPS */, ["product"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disable"]))
        : (_openBlock(), _createBlock(_component_AppInfiniteScroll, {
            key: 3,
            onLoad: loadCb,
            disable: _unref(isEnd) && !_unref(isLoading)
          }, {
            loading: _withCtx(() => [
              _createVNode(_component_AppSpinner, { class: "loading" })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedArray), (product) => {
                  return (_openBlock(), _createBlock(ProductCardItem, {
                    class: "product-list__item",
                    key: product.id,
                    product: product
                  }, null, 8 /* PROPS */, ["product"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disable"]))
}
}

})